<template>
  <div>
    <div class="static-footer" v-if="isFooter && !isLoading">
      <img
        :src="modulePropsData?.backGroundImage"
        alt="footer image"
        class="footer-bg-img"
      />
      <div class="footer-logo d-flex">
        <img
          :src="modulePropsData?.leftImageUrl"
          alt="footer image"
          class="footer-left-img"
        />
        <div class="pl16 pt32">
          <p class="text-hearty">{{ modulePropsData?.title }}</p>
          <!-- <div class="d-flex">
            <img
              :src="modulePropsData?.subtitleImageUrl"
              alt="fssai image"
              class="fssai"
            />
            <p class="lic-no pl5">{{ modulePropsData?.subtitle }}</p>
          </div> -->
          <p>{{ modulePropsData?.footerText }}</p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="pd30 bg-white clearfix d-flex flex-row">
        <div
          class="hide-shimmer-text shimmer-container rounded card-img-shimmer"
        >
          image
        </div>
        <div class="width80">
          <div class="hide-shimmer-text shimmer-container rounded">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded mt12">
            random tip subtitle text
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { staticImgBaseUrl } from "../config/apiEndpoints";

export default {
  name: "BottomStaticMessage",
  components: {},
  props: ["moduleProps"],
  data() {
    return {
      staticImgBaseUrl,
      modulePropsData: {},
      isFooter: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    setTimeout(() => {
      this.isFooter = true;
    }, 1000);
  },
  methods: {},
  computed: {
    isLoading() {
      return this.$store.state.Loader.isLoading;
    },
  },
};
</script>
